import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";

export function AdminRequiredValidator(isAdmin: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => (isAdmin ? Validators.required : null);
}
